import { createSlice } from '@reduxjs/toolkit';
import socket from '../../utils/socket';

const initialState = {
  comments: [],
  // comment: {},
  commentId: 0,
  error: false,
  isLoading: false
};

const slice = createSlice({
  name: 'comments',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    endLoading(state) {
      state.isLoading = false;
    },

    // ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      console.error(state.error);
    }
  }
});

// Reducer
export default slice.reducer;

export function editComment({ form, callback = null }) {
  const create = !form.id;
  const body = {
    ...(!create && { id: form.id }),
    ...(create && { shift_id: form.shiftId }),
    text: form.text,
    is_visible_client: form.isVisibleClient,
    is_visible_resource: form.isVisibleResource
  };
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = create ? await socket.post('/comments', body) : await socket.put('/comments', body);
      if (result.success) {
        callback({ result, success: true, message: 'Commentaire enregistré', variant: 'success' });
      }
      dispatch(slice.actions.endLoading());
      return result;
    } catch (error) {
      if (callback) {
        callback({
          success: false,
          message: "Erreur lors de l'envoi, réessayez ultérieurement",
          variant: 'error'
        });
      }

      dispatch(slice.actions.hasError(error));
      return error;
    }
  };
}

export function deleteComment({ form, callback = null }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.delete('/comments', { id: form.id });
      dispatch(slice.actions.endLoading());
      if (callback) {
        callback({
          success: true,
          message: 'Commentaire supprimé',
          variant: 'success'
        });
      }
      return result;
    } catch (error) {
      if (callback) {
        callback({
          success: true,
          message: 'Erreur lors de la suppression, réessayez ultérieurement',
          variant: 'error'
        });
      }
      dispatch(slice.actions.hasError(error));
      return error;
    }
  };
}
